module.exports = __webpack_public_path__ + "img/GoPay-1110x450.979d3f1e.png";